import React, {useEffect, useState} from 'react';
import Input from "../../UI/Input";
import "./ConditionSection.scss"
import objectDataHolder from "../../Hooks/ObjectDataHolder";
import {formatToPersianAddComma, parseToEnRemoveComma} from "../../../utils/CommaSeparator";
import {toast} from "react-toastify";

const ConditionSection = (props) => {
  const {conditionDataFromBackEnd, conditionTableData} = props;

  // valueList to show Values After select an entity
  const [valueList, setValueList] = objectDataHolder({type: "", data: [],});
  // row to show every Row in table and it will be Lift Up

  const initialRow = {
    field: "",
    textField: "",

    operator: "",
    textOperator: "",

    value: "",
    textValue: "",

    andOr: "nullSelect",
    textAndOr: "nullSelect",
  }
  const [row, setRow] = objectDataHolder(initialRow)

  // empty || andOr || and || or
  const [conditionRadio, setConditionRadio] = objectDataHolder({value: "nullSelect"})

  useEffect(() => {
    // در صورتی که دفعه اول بود یا هیچ شرطی تو جدول نبود باید مقدار پیش فرض بدون شرط انتخاب شده باشه
    if(conditionTableData.length===0){
      setConditionRadio({value: ''})
      setRow({andOr: '', textAndOr: "بدون شرط"})
    }
  }, [conditionTableData])

  const indexFieldChangeHandler = (e) => {

    const field = e.target.value;
    let textField = "";

    //to use in  another Array
    let type = "";
    let data = [];
    conditionDataFromBackEnd.forEach(v => {
      if (v.value === field) {
        textField = v.label
        type = v.type
        data = v.data
      }
    })
    // here i need to set value and textValue to Zero
    setRow({field, textField, value: "", textValue: ""})
    setValueList({type, data})


  }


  if (!conditionDataFromBackEnd) {
    return null
  }


  const selectOptionChangeHandler = (e, type, key, textKey) => {
    const value = e.target.value;
    const textValue = type === "select" ? e.target.options[e.target.selectedIndex].text : parseToEnRemoveComma(value)
    const object = {
      [key]: value,
      [textKey]: textValue,
    }
    setRow(object)
  }

  const AddToTableHandler = () => {

    if (
      row.field === '' ||
      row.textField === '' ||

      row.operator === '' ||
      row.textOperator === '' ||

      row.value === '' ||
      row.textValue === '' ||

      row.andOr === 'nullSelect' ||
      row.textAndOr === 'nullSelect'

    ) {
      toast.error("لطفا موارد مربوط به شرط را بررسی کنید")
      return
    }

    setConditionRadio({value: "nullSelect"});
    setRow(initialRow)
    props.AddToTableHandler(row)

  }


  return (
    <div className={"ConditionSection"}>

      <div className={"row"}>

        <div className={"col-12 col-md-6 position-relative mt-3"}>
          <div className={"position-absolute labelTopOfInput"}>فیلد یا فیلدهای شاخص</div>
          <select

            onChange={indexFieldChangeHandler}
            className={"w-100"}
            value={row.field}
          >
            <option value="">انتخاب کنید</option>
            {conditionDataFromBackEnd.map((v, index) =>
              <option key={index} value={v.value}>{v.label}</option>
            )}

          </select>
        </div>

        <div className={"col-12 col-md-6 position-relative mt-3"}>
          <div className={"position-absolute labelTopOfInput"}>عملگر</div>

          <select
            className={"w-100"}
            onChange={e => selectOptionChangeHandler(e, "select", "operator", "textOperator")}
            value={row.operator}
          >
            <option value="">انتخاب کنید</option>
            <option value=">">بزرگتر</option>
            <option value=">=">بزرگتر مساوی</option>
            <option value="=">مساوی</option>
            <option value="!=">مخالف</option>
            <option value="<">کوچیکتر</option>
            <option value="<=">کوچیکتر مساوی</option>
          </select>
        </div>

      </div>
      <div className={"row mt-3"}>

        <div className={"col-12 col-md-6 position-relative mt-3"}>
          {valueList.type === "" ? <></> :
            valueList.type === "select" ? <>
                <div className={"position-absolute labelTopOfInput"}>مقدار</div>
                <select
                  value={row.value}
                  className={"w-100"}
                  onChange={e => selectOptionChangeHandler(e, "select", "value", "textValue")}
                >
                  <option value="nullSelect">انتخاب کنید</option>
                  {valueList.data.map((v, index) =>
                    <option key={index} value={v.value}>{v.label}</option>
                  )}
                </select>
              </> :
              valueList.type === "number" ? <>
                  <div className={"position-absolute labelTopOfInput"}>مقدار</div>
                  <input
                    className={"w-100"}
                    placeholder={"مقدار عددی"}
                    type={"text"}
                    value={row.value === "" ? "" : formatToPersianAddComma(row.value)}
                    onChange={e => {
                      // number Only

                      e.target.value = parseToEnRemoveComma(e.target.value)
                      e.target.value = e.target.value.replace(/[^0-9]/g, '')

                      selectOptionChangeHandler(e, "text", "value", "textValue")

                    }
                    }

                  />

                </> :
                valueList.type === "string" ? <>
                    <div className={"position-absolute labelTopOfInput"}>مقدار</div>
                    <input
                      placeholder={"مقدار رشته ای"}
                      className={"w-100"}
                      type={"text"}
                      value={row.value}
                      onChange={e => {
                        selectOptionChangeHandler(e, "text", "value", "textValue")
                      }
                      }
                    />
                  </> :
                  <></>
          }
        </div>
        <div className={"col-12 col-md-6 position-relative mt-3"}>
          <div className={"position-absolute labelTopOfInput"}>شرط</div>
          <div className={"conditionSelectSection d-flex align-items-center justify-content-between"}>
            <input
              type="radio"
              name={"condition"}
              id={"noCondition"}

              onChange={e => {
                setConditionRadio({value: ''})
                setRow({andOr: '', textAndOr: "بدون شرط"})
              }}

              disabled={conditionTableData.length !== 0}
              checked={conditionRadio.value === ''}

            />
            <label htmlFor="noCondition"
                   className={conditionTableData.length !== 0 ? "px-3 disabled" : "px-3"}
            >بدون شرط</label>

            <input type="radio" name={"condition"} id={"andId"}
                   disabled={conditionTableData.length === 0}

                   onChange={e => {
                     setConditionRadio({value: 'AND'})
                     setRow({andOr: 'AND', textAndOr: "و"})
                   }}
                   checked={conditionRadio.value === 'AND'}


            />
            <label htmlFor="andId"
                   className={conditionTableData.length === 0 ? "px-3 disabled" : "px-3"}

            >و</label>


            <input type="radio" name={"condition"} id={"orId"}
                   disabled={conditionTableData.length === 0}


                   onChange={e => {
                     setConditionRadio({value: 'OR'})
                     setRow({andOr: 'OR', textAndOr: "یا"})
                   }}
                   checked={conditionRadio.value === 'OR'}


            />
            <label htmlFor="orId"
                   className={conditionTableData.length === 0 ? "px-3 disabled" : "px-3"}
            >یا</label>

          </div>
        </div>

      </div>
      <div className={"text-center my-3"}>
        <button className={"btn btn-primary"}
                onClick={AddToTableHandler}
        >ثبت
        </button>
      </div>

    </div>
  );
};

export default ConditionSection;
